import { render, staticRenderFns } from "./MacrosSetup.vue?vue&type=template&id=1821b60a"
import script from "./MacrosSetup.vue?vue&type=script&lang=js"
export * from "./MacrosSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports